import { NavigationData } from 'core/slices/models';
import { findReport } from 'domain/functions/findReport';

const removeBookmarkFromNavData = (
  data: NavigationData,
  reportId: string,
  bookmarkId: number
): NavigationData => {
  // Deep clone navigationData to avoid mutating original
  const newNavData = JSON.parse(JSON.stringify(data));
  const reportNode = findReport(newNavData, reportId);
  if (reportNode) {
    if (!reportNode.bookmarks) {
      reportNode.bookmarks = [];
    }

    const bookmark = reportNode.bookmarks.find(b => b.id === bookmarkId);
    const id = reportNode.bookmarks.indexOf(bookmark);
    reportNode.bookmarks.splice(id, 1);
  }
  return newNavData;
};

export default removeBookmarkFromNavData;
